import aremo_logo from "../img/clients/aremo_logo.png";
import asm_logo from "../img/clients/asm_logo.png";
import bogg_logo from "../img/clients/bogg_logo.png";
import bls_logo from "../img/clients/bls_logo.png";
import bernmobil_logo from "../img/clients/bernmobil.png";
import cheminsDeFerJura_logo from "../img/clients/cheminsdefer_jura_logo.png";
import churbus_logo from "../img/clients/churbus_logo.png";
import engadin_logo from "../img/clients/engadinbus_logo.png";
import forchbahn_logo from "../img/clients/forchbahn_logo.png";
import gwb_logo from "../img/clients/gwb_logo.png";
import postauto_logo from "../img/clients/postauto_logo.png";
import rbs_logo from "../img/clients/rbs_logo.png";
import sbb_logo from "../img/clients/sbb_logo.png";
import sob_logo from "../img/clients/sob_logo.png";
import win_logo from "../img/clients/stadtbus_winterthur_logo.png";
import szu_logo from "../img/clients/szu_logo.png";
import sti_logo from "../img/clients/sti_logo.png";
import tmr_logo from "../img/clients/tmr_logo.png";
import trenord_logo from "../img/clients/trenord_logo.png";
import vbg_logo from "../img/clients/vbg_logo.png";
import vbz_logo from "../img/clients/vbz_logo.png";
import vzo_logo from "../img/clients/vzo_logo.png";
import travys_logo from "../img/clients/travys_logo.png";
import rvf_logo from "../img/clients/rvf_logo.png";

const clientLogos = [
  {
    id: "aremo",
    src: aremo_logo,
  },
  {
    id: "asm",
    src: asm_logo,
  },
  {
    id: "bernmobil",
    src: bernmobil_logo,
  },
  {
    id: "bls",
    src: bls_logo,
  },
  {
    id: "bogg",
    src: bogg_logo,
  },
  {
    id: "chemins de fer - jura",
    src: cheminsDeFerJura_logo,
  },
  {
    id: "churbus",
    src: churbus_logo,
  },
  {
    id: "engadinbus",
    src: engadin_logo,
  },
  {
    id: "forchbahn",
    src: forchbahn_logo,
  },
  {
    id: "gwb",
    src: gwb_logo,
  },
  {
    id: "postauto",
    src: postauto_logo,
  },
  {
    id: "rbs",
    src: rbs_logo,
  },
  {
    id: "rvf",
    src: rvf_logo,
  },
  {
    id: "sbb",
    src: sbb_logo,
  },
  {
    id: "sob",
    src: sob_logo,
  },
  {
    id: "sti",
    src: sti_logo,
  },
  {
    id: "szu",
    src: szu_logo,
  },
  {
    id: "tmr",
    src: tmr_logo,
  },
  {
    id: "travys",
    src: travys_logo,
  },
  {
    id: "trenord",
    src: trenord_logo,
  },
  {
    id: "vbg",
    src: vbg_logo,
  },
  {
    id: "vbz",
    src: vbz_logo,
  },
  {
    id: "vzo",
    src: vzo_logo,
  },
  {
    id: "win",
    src: win_logo,
  },
];

export default clientLogos;
